import { Series, SimulationSeries, TableDashletSingleSeries } from '../types';

/**
 * Type guard to check if a series is a sensor series
 * @param series - The series to check
 * @returns True if the series is a sensor series
 */
export const isSensorSeries = (
  series: TableDashletSingleSeries | undefined
): series is Series => {
  return series !== undefined && 'sensorId' in series && 'resolution' in series;
};

/**
 * Type guard to check if a series is a simulation series
 * @param series - The series to check
 * @returns True if the series is a simulation series
 */
export const isSimulationSeries = (
  series: TableDashletSingleSeries
): series is SimulationSeries => {
  // Check for simulation-specific properties and ensure it's not a sensor series
  return (
    typeof series === 'object' &&
    series !== null &&
    'database_id' in series &&
    'object_id' in series &&
    !('sensorId' in series)
  );
};

/**
 * Gets the type of a series
 * @param series - The series to check
 * @returns The type of the series
 */
export const getSeriesType = (
  series: TableDashletSingleSeries
): 'simulation' | 'sensor' | 'custom' => {
  if (isSimulationSeries(series)) {
    return 'simulation';
  }
  if (isSensorSeries(series)) {
    return 'sensor';
  }
  return 'custom';
};
